export interface Site {
  id: string;
  name: string;
  url: string;
  description: string;
  category: string;
  rating: number;
  tags: string[];
  thumbnail: string;
  featured: boolean;
  visitors: string;
}

export const sites: Site[] = [
  {
    id: 'site-1',
    name: '星空影视',
    url: 'https://example.com',
    description: '海量高清成人影视资源，每日更新热门影片，支持多线路播放，流畅观影体验，分类齐全满足各类需求',
    category: 'video-platforms',
    rating: 4.8,
    tags: ['高清', '影视', '热门'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20streaming%20platform%20interface%20with%20glowing%20red%20accents%2C%20modern%20minimalist%20dark%20UI%20design%2C%20movie%20thumbnails%20grid%2C%20ambient%20low%20light%2C%20premium%20entertainment%20aesthetic%2C%20sleek%20tech%20design&width=400&height=240&seq=site-video-01&orientation=landscape',
    featured: true,
    visitors: '12.5万',
  },
  {
    id: 'site-2',
    name: '极速视频站',
    url: 'https://example.com',
    description: '高速加载成人视频平台，CDN全球加速，4K超清画质，智能推荐算法精准匹配喜好',
    category: 'video-platforms',
    rating: 4.7,
    tags: ['4K', '高速', '推荐'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Fast%20streaming%20service%20dark%20interface%20with%20speed%20indicators%2C%20modern%20dark%20theme%20design%2C%20video%20player%20mockup%2C%20red%20and%20black%20color%20scheme%2C%20tech%20focused%20minimal%20design&width=400&height=240&seq=site-video-02&orientation=landscape',
    featured: true,
    visitors: '9.8万',
  },
  {
    id: 'site-3',
    name: '热门直播间',
    url: 'https://example.com',
    description: '超人气成人直播互动平台，24小时不间断直播，海量主播在线，支持弹幕互动与私聊',
    category: 'live-streaming',
    rating: 4.6,
    tags: ['直播', '互动', '24h'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Live%20streaming%20platform%20dark%20interface%20with%20grid%20of%20stream%20thumbnails%2C%20chat%20sidebar%2C%20modern%20dark%20UI%2C%20red%20notification%20badges%2C%20entertainment%20broadcast%20design&width=400&height=240&seq=site-live-01&orientation=landscape',
    featured: true,
    visitors: '15.2万',
  },
  {
    id: 'site-4',
    name: '美图集锦',
    url: 'https://example.com',
    description: '精选高清成人图片社区，百万图库每日更新，支持相册收藏与智能分类浏览',
    category: 'image-gallery',
    rating: 4.5,
    tags: ['高清', '图库', '收藏'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Photo%20gallery%20platform%20dark%20interface%20with%20image%20grid%20layout%2C%20masonry%20style%20thumbnails%2C%20modern%20dark%20theme%2C%20minimalist%20gallery%20design%2C%20subtle%20warm%20accents&width=400&height=240&seq=site-image-01&orientation=landscape',
    featured: false,
    visitors: '8.3万',
  },
  {
    id: 'site-5',
    name: '深夜社区',
    url: 'https://example.com',
    description: '活跃成人交流社区，海量资源分享帖，热门讨论区，注册会员享专属内容',
    category: 'forums',
    rating: 4.4,
    tags: ['社区', '分享', '会员'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Online%20community%20forum%20dark%20interface%20with%20thread%20list%2C%20user%20avatars%2C%20discussion%20topics%2C%20modern%20dark%20theme%20design%2C%20warm%20amber%20accent%20colors&width=400&height=240&seq=site-forum-01&orientation=landscape',
    featured: false,
    visitors: '6.7万',
  },
  {
    id: 'site-6',
    name: '悦读书城',
    url: 'https://example.com',
    description: '海量成人小说在线阅读平台，涵盖各类题材，支持离线下载与书签功能',
    category: 'novels',
    rating: 4.5,
    tags: ['小说', '阅读', '下载'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Digital%20reading%20platform%20dark%20interface%20with%20book%20covers%20displayed%2C%20library%20style%20layout%2C%20modern%20dark%20theme%2C%20warm%20reading%20lamp%20glow%2C%20elegant%20typography&width=400&height=240&seq=site-novel-01&orientation=landscape',
    featured: false,
    visitors: '5.4万',
  },
  {
    id: 'site-7',
    name: '缘聚交友',
    url: 'https://example.com',
    description: '真实成人社交交友平台，智能匹配算法，安全隐私保护，快速找到志同道合的朋友',
    category: 'dating',
    rating: 4.3,
    tags: ['交友', '匹配', '隐私'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Social%20dating%20platform%20dark%20interface%20with%20profile%20cards%2C%20heart%20icons%2C%20modern%20dark%20theme%20design%2C%20romantic%20warm%20lighting%2C%20minimalist%20match%20interface&width=400&height=240&seq=site-dating-01&orientation=landscape',
    featured: false,
    visitors: '7.1万',
  },
  {
    id: 'site-8',
    name: '游戏乐园',
    url: 'https://example.com',
    description: '精选成人向游戏平台，涵盖养成、模拟、互动等多种类型，在线即玩无需下载',
    category: 'games',
    rating: 4.6,
    tags: ['游戏', '在线', '互动'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Gaming%20platform%20dark%20interface%20with%20game%20covers%20grid%2C%20controller%20icons%2C%20modern%20dark%20theme%2C%20neon%20game%20aesthetic%2C%20arcade%20style%20design%20elements&width=400&height=240&seq=site-game-01&orientation=landscape',
    featured: true,
    visitors: '11.3万',
  },
  {
    id: 'site-9',
    name: '极光视频',
    url: 'https://example.com',
    description: '新锐成人视频平台，AI智能去重推荐，独家高清资源，纯净无广告观影体验',
    category: 'video-platforms',
    rating: 4.4,
    tags: ['AI推荐', '无广告', '独家'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Premium%20video%20platform%20dark%20interface%20with%20AI%20recommendation%20carousel%2C%20sleek%20minimal%20dark%20design%2C%20cinematic%20movie%20posters%2C%20clean%20modern%20layout%2C%20subtle%20gradient%20accents&width=400&height=240&seq=site-video-03&orientation=landscape',
    featured: false,
    visitors: '4.9万',
  },
  {
    id: 'site-10',
    name: '午夜直播秀',
    url: 'https://example.com',
    description: '热门午夜直播平台，高颜值主播在线互动，VIP专属直播间，尊享高清画质',
    category: 'live-streaming',
    rating: 4.5,
    tags: ['午夜', 'VIP', '高颜值'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Night%20broadcast%20platform%20dark%20interface%20with%20VIP%20room%20preview%2C%20premium%20dark%20theme%2C%20gold%20accent%20details%2C%20luxury%20entertainment%20design%2C%20exclusive%20streaming%20aesthetic&width=400&height=240&seq=site-live-02&orientation=landscape',
    featured: false,
    visitors: '10.6万',
  },
  {
    id: 'site-11',
    name: '写真图库',
    url: 'https://example.com',
    description: '专业成人写真摄影图库，高清套图下载，分类详尽，支持按风格与模特检索',
    category: 'image-gallery',
    rating: 4.7,
    tags: ['写真', '套图', '专业'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Professional%20photo%20studio%20gallery%20dark%20interface%2C%20portfolio%20style%20layout%2C%20minimalist%20dark%20theme%2C%20elegant%20photography%20display%2C%20subtle%20warm%20lighting%20accents&width=400&height=240&seq=site-image-02&orientation=landscape',
    featured: false,
    visitors: '6.2万',
  },
  {
    id: 'site-12',
    name: '资源中转站',
    url: 'https://example.com',
    description: '成人资源聚合下载平台，网盘资源搜索，磁力链接聚合，一站式资源获取工具',
    category: 'tools',
    rating: 4.2,
    tags: ['下载', '聚合', '搜索'],
    thumbnail: 'https://readdy.ai/api/search-image?query=Download%20tool%20platform%20dark%20interface%2C%20file%20search%20dashboard%2C%20modern%20dark%20theme%2C%20tech%20and%20utility%20focused%20design%2C%20clean%20minimal%20layout%20with%20data%20visualization&width=400&height=240&seq=site-tool-01&orientation=landscape',
    featured: false,
    visitors: '8.9万',
  },
];

export const getSitesByCategory = (categorySlug: string) => {
  return sites.filter((s) => s.category === categorySlug);
};

export const getFeaturedSites = () => {
  return sites.filter((s) => s.featured);
};

export const getSiteById = (id: string) => {
  return sites.find((s) => s.id === id);
};